module.exports = __webpack_public_path__ + "static/scale-model-of-the-escape-room-indianapolis-in-indianapolis-indiana-ea1caf74ba848312a324b28a9a658f20.png";